module.exports = "<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\r\n<router-outlet></router-outlet>\r\n"